var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container-fluid index-page" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12 col-sm-12" }, [
          _c("div", { staticClass: "welcome-block" }, [
            _c("div", { staticClass: "title" }, [_vm._v("Hello!!")]),
            _c("div", { staticClass: "desc" }, [
              _vm._v("歡迎回來iRecruit管理系統。"),
            ]),
            _c("img", {
              attrs: {
                src: require("@/assets/img/index/工作區域 3.png"),
                alt: "",
              },
            }),
          ]),
          _c("div", { staticClass: "digital-list" }),
        ]),
        _c("div", { staticClass: "col-md-12 col-sm-12" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }